module.exports = __webpack_public_path__ + "static/media/FullFox.4a77cb53.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/FullFox.svg
// module id = 121
// module chunks = 0